import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#7B1FA2',
      light: '#CE93D8',
      dark: '#4A148C',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#E040FB',
      light: '#F3A5FF',
      dark: '#AA00FF',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#FAF5FF',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1A1A2E',
      secondary: '#4A4A68',
    },
    success: {
      main: '#4CAF50',
    },
    categoryFinancial: {
      main: '#F9A825',
      light: '#FFF8E1',
    },
    categoryOrganizations: {
      main: '#00897B',
      light: '#E0F2F1',
    },
    categoryMedical: {
      main: '#1E88E5',
      light: '#E3F2FD',
    },
    categoryLegal: {
      main: '#5C6BC0',
      light: '#E8EAF6',
    },
    categoryIdentity: {
      main: '#EF5350',
      light: '#FFEBEE',
    },
  },
  typography: {
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
    h1: {
      fontWeight: 700,
      letterSpacing: '-0.02em',
    },
    h2: {
      fontWeight: 700,
      letterSpacing: '-0.01em',
    },
    h3: {
      fontWeight: 600,
      letterSpacing: '-0.01em',
    },
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
    body1: {
      lineHeight: 1.7,
    },
    body2: {
      lineHeight: 1.6,
    },
    button: {
      fontWeight: 600,
      textTransform: 'none',
      letterSpacing: '0.01em',
    },
  },
  shape: {
    borderRadius: 12,
  },
  shadows: [
    'none',
    '0 1px 3px rgba(123, 31, 162, 0.06)',
    '0 2px 8px rgba(123, 31, 162, 0.08)',
    '0 4px 16px rgba(123, 31, 162, 0.10)',
    '0 6px 24px rgba(123, 31, 162, 0.12)',
    '0 8px 32px rgba(123, 31, 162, 0.14)',
    '0 12px 40px rgba(123, 31, 162, 0.16)',
    '0 16px 48px rgba(123, 31, 162, 0.18)',
    ...Array(17).fill('0 16px 48px rgba(123, 31, 162, 0.18)'),
  ],
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          padding: '12px 28px',
          fontSize: '1rem',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 6px 24px rgba(123, 31, 162, 0.25)',
          },
          '&:active': {
            transform: 'translateY(0)',
          },
        },
        contained: {
          background: 'linear-gradient(135deg, #7B1FA2 0%, #9C27B0 50%, #E040FB 100%)',
          color: '#FFFFFF',
          '&:hover': {
            background: 'linear-gradient(135deg, #6A1B9A 0%, #8E24AA 50%, #D500F9 100%)',
          },
        },
        outlined: {
          borderWidth: 2,
          '&:hover': {
            borderWidth: 2,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 2px 12px rgba(123, 31, 162, 0.08)',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            boxShadow: '0 8px 32px rgba(123, 31, 162, 0.15)',
          },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          borderRadius: '16px !important',
          border: '1px solid rgba(123, 31, 162, 0.08)',
          boxShadow: '0 2px 8px rgba(123, 31, 162, 0.06)',
          '&:before': {
            display: 'none',
          },
          '&.Mui-expanded': {
            margin: '8px 0',
            boxShadow: '0 4px 20px rgba(123, 31, 162, 0.12)',
          },
          overflow: 'hidden',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          padding: '8px 24px',
          minHeight: 64,
          '&.Mui-expanded': {
            minHeight: 64,
          },
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          padding: '0 24px 20px',
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          height: 6,
          borderRadius: 3,
          backgroundColor: 'rgba(123, 31, 162, 0.08)',
        },
        bar: {
          borderRadius: 3,
          background: 'linear-gradient(90deg, #7B1FA2, #E040FB)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 12,
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#CE93D8',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#7B1FA2',
              borderWidth: 2,
            },
          },
        },
      },
    },
  },
});

export default theme;
